import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Invoice } from '@models/invoice.model';
import { InvoiceServiceProvider } from '../../../../../../shared/services/invoice/invoice-service/invoice.service';
import { SettingsProvider } from '@services/settings/settings';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CustomizedLabels } from '@models/models';

@Component({
	selector: 'invoice-info-table',
	template: require('./invoice-info-table.html'),
	styles: [require('./invoice-info-table.scss')]
})
export class InvoiceInfoTableComponent implements OnInit, OnDestroy {
	get invoice(): number {
		return this.invoice;
	}

	@Input('invoice')
	set product(value: Invoice) {
		this.data = value;
		this.setInvoiceStamp();
	}

	businessNumberLabelName: string;

	data: Invoice;
	imageStatusInvoice = '';
	private unsubscribe: Subject<void> = new Subject<void>();

	constructor(
		private invoiceService: InvoiceServiceProvider,
		private settingsService: SettingsProvider
	) {}

	ngOnInit() {
		this.setInvoiceStamp();
		this.subscribeToCustomizeLabelsChange();
	}

	ngOnDestroy() {
		this.unsubscribe.next();
		this.unsubscribe.complete();
	}

	private subscribeToCustomizeLabelsChange(): void {
		this.settingsService.customizeLabelsObservable
			.pipe(takeUntil(this.unsubscribe))
			.subscribe(
				(customizeLabels: CustomizedLabels): string =>
					(this.businessNumberLabelName = customizeLabels.businessNumberLabel)
			);
	}

	private setInvoiceStamp() {
		this.imageStatusInvoice = this.invoiceService.getInvoiceStampImageSrc(
			this.data.sent
		);
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=os2z8rc99lf!./web/modern/components/invoices/invoice-view/invoice-info-table/invoice-info-table.ts